// Utility function for cross-browser and iOS-compatible scrolling to top
export const scrollToTop = () => {
    // Multiple methods to ensure compatibility across all browsers and devices
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    
    // For iOS Safari in some edge cases
    if (window.pageYOffset > 0) {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
    }
};

// Utility function for delayed navigation with scroll reset
export const navigateWithScrollReset = (navigate, path, delay = 10) => {
    // Scroll to top first
    scrollToTop();
    
    // Small delay to ensure scroll happens before navigation (iOS fix)
    setTimeout(() => {
        navigate(path);
    }, delay);
};